import { format } from 'd3';

export const capitalizeFirstLetter = (str) =>
  str?.toString().charAt(0).toUpperCase() + str?.toString().slice(1);

export const formatFixed = (value: number, digits = 1): string => {
  if (value == null || isNaN(value)) return '';
  return format(`.${digits}f`)(value);
};
